import { Box, Button, Stack, Typography } from '@mui/material'

export type AuthPath = 'kone' | 'subcontractor'

const STORAGE_KEY = 'authPath'

export const readAuthPath = (): AuthPath | null => {
  const url = new URL(window.location.href)
  const fromQuery = url.searchParams.get('login')
  if (fromQuery === 'kone' || fromQuery === 'subcontractor') {
    window.sessionStorage.setItem(STORAGE_KEY, fromQuery)
    return fromQuery
  }
  const stored = window.sessionStorage.getItem(STORAGE_KEY)
  if (stored === 'kone' || stored === 'subcontractor') return stored
  return null
}

export const clearAuthPath = (): void => {
  window.sessionStorage.removeItem(STORAGE_KEY)
}

type Props = {
  onPick: (path: AuthPath) => void
}

const LoginChooser = ({ onPick }: Props): JSX.Element => {
  const pick = (path: AuthPath) => {
    window.sessionStorage.setItem(STORAGE_KEY, path)
    onPick(path)
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      px={2}
    >
      <Stack spacing={3} alignItems="center" maxWidth={400} width="100%">
        <Typography variant="h5" align="center">
          Sign in to KONE Safety Method Passport
        </Typography>
        <Typography variant="body2" align="center" color="text.secondary">
          Choose how you want to sign in.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={() => pick('kone')}
        >
          KONE Employee
        </Button>
        <Button
          variant="outlined"
          fullWidth
          size="large"
          onClick={() => pick('subcontractor')}
        >
          Subcontractor
        </Button>
      </Stack>
    </Box>
  )
}

export default LoginChooser
